document.addEventListener('page:loaded', function() {
  if (window.innerWidth > 767) return;
  if (window.location.pathname.startsWith('/products/')) return;

  function waitForEls(cb) {
    const int = setInterval(() => {
      const tidio = document.querySelector('#tidio-chat');
      const headerSection = document.querySelector('.header-section');
      if (tidio && headerSection) {
        clearInterval(int);
        cb({tidio, headerSection});
      }
    }, 100);
  }

  waitForEls(({ tidio, headerSection }) => {
    tidio.style.transition = "transform 0.3s cubic-bezier(.42,0,.58,1)";

    function syncTidioToHeader() {
      if (headerSection.classList.contains('header-hidden')) {
        tidio.style.transform = "translateY(-60px)";
      } else {
        tidio.style.transform = "translateY(0)";
      }
    }

    // Initial run
    syncTidioToHeader();

    window.addEventListener('scroll', syncTidioToHeader, { passive: true });
  });
});
